import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCloudArrowDown } from '@fortawesome/free-solid-svg-icons';
import Spiner from '../components/Spiner';
import axios from 'axios';
import commonFunc from '../common';

const BE_API_URL = process.env.REACT_APP_BACKEND_API_V2_URL;

const FbDownload = () => {
  const [url, setUrl] = useState('');
  const [downloadInfo, setDownloadInfo] = useState([])
  const [previewVideo, setPreviewVideo] = useState()
  const [linkChangesCount, setLinkChangesCount] = useState(0)
  const formatTypes = ['sd', 'hd']

  const handleGetDownloadVideoInfo = async () => {
    setLinkChangesCount(1)
    try {
      axios.post(`${BE_API_URL}/api/download/video`, {
        url
      })
      .then(function (response) {
        setDownloadInfo(response.data.formats)
        setLinkChangesCount(0)
      })
      .catch(function (error) {
        console.log(error);
      });
    } catch (err) {
    }
  };

  const generateFileName = (extension, prefix) => {
    const now = new Date();
  
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed, so add 1
    const day = String(now.getDate()).padStart(2, '0');
    
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const seconds = String(now.getSeconds()).padStart(2, '0');
  
    const fileName = `${year}-${month}-${day}_${hours}-${minutes}-${seconds}.${extension}`;
    return prefix + `_` + fileName;
  }

  const handleClickToDownload = async (e) => {
    e.preventDefault();
    try {
      const videoUrl = e.target.href
      const fileName = e.target.download
      const link = document.createElement('a');
      link.href = videoUrl;
      link.setAttribute('target', '_blank')
      link.setAttribute('download', fileName)
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      commonFunc.notifyFailure('Something went wrong!')
    }
  }

  useEffect(() => {
    if(downloadInfo) {
      setPreviewVideo(downloadInfo.filter((format) => formatTypes.includes(format.format_id) )[0])
    }
    if (!url) {
      setPreviewVideo(null)
      setDownloadInfo([])
      setLinkChangesCount(0)
    }
  },[downloadInfo, url])

  return (
    <div className="grid grid-cols-1 xl:grid-cols-1 xl:gap-4">
      <div className="col-span-2 xl:col-auto">
        <div className="p-4 space-y-6 bg-white border border-gray-200 rounded-lg shadow-sm 2xl:col-span-2 dark:border-gray-700 sm:p-6 dark:bg-gray-800">
          <div className="px-4 py-2 pt-20 text-gray-400 rounded dark:border-gray-600 flex justify-center">
            <div className="relative w-2/4">
              <input
                type="url"
                value={url}
                onChange={(e) => setUrl(e.target.value)}
                className="block p-4 w-full z-20 text-sm text-gray-900 bg-gray-50 rounded-lg rounded-s-gray-100 rounded-s-2 border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:border-blue-500"
                required={true}
                placeholder='Enter Facebook video URL'
              />
              <button
                type="button"
                onClick={handleGetDownloadVideoInfo}
                disabled={!url}
                className="absolute top-0 end-0 px-4 p-2.5 h-full text-sm font-medium text-white bg-blue-700 rounded-e-lg border border-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
              >
                Submit
              </button>
              <div id="tooltipContent" class="absolute z-10 invisible inline-block px-3 py-2 text-sm font-medium text-white transition-opacity duration-300 bg-gray-900 rounded-lg shadow-sm opacity-0 tooltip dark:bg-gray-700">
                Coppied
                <div class="tooltip-arrow" data-popper-arrow></div>
              </div>
            </div>
          </div>
          <div className="px-4 py-2 text-gray-400 dark:border-gray-600 flex justify-center">
            <Spiner visible={!previewVideo && linkChangesCount > 0} />
            { previewVideo &&  (
              <video className="border w-2/4 border-gray-200 rounded-lg" controls>
                <source src={previewVideo.url} type={`video/${previewVideo.ext}`} />
                Your browser does not support the video tag.
              </video>
            ) }
          </div>
          <div className="px-4 py-2 text-gray-400 dark:border-gray-600 flex justify-center">
            { downloadInfo && downloadInfo.filter((format) => formatTypes.includes(format.format_id) ).map((format) => {
              return (
                <div className='block'>
                  <button onClick={(e) => handleClickToDownload(e)} href={format.url} download={`download_` + generateFileName(format.ext, format.format_id)} className="text-white mt-4 bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-md px-5 py-4 text-center inline-flex items-center me-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">
                    <FontAwesomeIcon icon={faCloudArrowDown}/>
                    &nbsp;{ format.ext.toUpperCase() } { format.format_id.toUpperCase() }
                  </button>
                </div>
              )
            }) }
          </div>
        </div>
      </div>
    </div>
  )
}

export default FbDownload;
